// Module
var code = `<select
    ng-model="\$ctrl.innerModel"
    ng-change="\$ctrl.updateNgModel()"
    ng-disabled="\$ctrl.\$attrs.disabled"
    ng-options="user.id as user.label for user in \$ctrl.options">
  <option ng-if="\$ctrl.hasEmptyOption()"></option>
</select>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/user-select/user-select.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;